import React, { useMemo } from "react";
import TotalForm from "./InvoiceProduct/TotalForm";

const toNum = (v) => {
  const n = Number(v ?? 0);
  return Number.isFinite(n) ? n : 0;
};

const round2 = (n) => Math.round((toNum(n) + 1e-10) * 100) / 100;

export default function InvoiceTotal({
  descripcion,
  setDescripcion,
  productTotals,
  accountTotals,
}) {
  const merged = useMemo(() => {
    const p = productTotals || {};
    const a = accountTotals || {};

    const totals = {
      sub15: round2(toNum(p.sub15) + toNum(a.sub15)),
      sub5: round2(toNum(p.sub5) + toNum(a.sub5)),
      sub0: round2(toNum(p.sub0) + toNum(a.sub0)),
      descuento: round2(toNum(p.descuento) + toNum(a.descuento)),
    };

    const iva15 = round2(toNum(p.iva15) + toNum(a.iva15));
    const iva5 = round2(toNum(p.iva5) + toNum(a.iva5));
    const ice = round2(toNum(p.ice) + toNum(a.ice));

    const total = round2(
      totals.sub15 + totals.sub5 + totals.sub0 + iva15 + iva5 + ice
    );

    return { totals, iva15, iva5, ice, total };
  }, [productTotals, accountTotals]);

  return (
    <TotalForm
      descripcion={descripcion}
      setDescripcion={setDescripcion}
      totals={merged.totals}
      iva15={merged.iva15}
      iva5={merged.iva5}
      total={merged.total}
    />
  );
}
